import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import asteroid from "../assets/images/asteroidf.gif";

function Neo({ neo }) {
  const { id, name, nasa_jpl_url, close_approach_data } = neo;

  return (
    <div className="neo-card">
      <h1>Name: {name}</h1>
      <a href={nasa_jpl_url} rel="noopener noreferrer" target="_blank">
        ID: {id}
      </a>
      <p>Full Time : {close_approach_data[0].close_approach_date_full}</p>
      <p>Orbiting Body : {close_approach_data[0].orbiting_body}</p>
      <p>
        Velocity (KMH):{" "}
        {close_approach_data[0].relative_velocity.kilometers_per_hour}
      </p>
      <div className="Aster">
        <img src={asteroid} alt="asteroid" />
      </div>
    </div>
  );
}

export default Neo;
